export default {
    name          : 'modals',
    _modals       : null,
    _closes       : null,

    init() {
        this.run();
    },

    run()
    {

        setTimeout(this.initModalBtn.bind(this), 1000);
        this.initModalClose();
        
    },

    initModalClose()
    {
        this._closes = document.querySelectorAll('.js-modal__close');

        if (!this._closes) {
            return;
        }

        this._closes.forEach(el => {
            el.addEventListener('click', el => {
                const modal = el.target.closest('.modal');
                this.toggle(modal);
                
            });
        });

    },

    initModalBtn()
    {
        this._modals = document.querySelectorAll('.modal-btn');

        if (!this._modals) {
            return;
        }


        this._modals.forEach(modal => {
            const modalBoxId = modal.dataset.target;
            modal.addEventListener('click', el => {
                this.toggle(document.getElementById(modalBoxId));
            });
        });

    },
    toggle(el){
        el.classList.toggle('active');
        document.querySelector('.body').classList.toggle('no-scroll');
    }

}